module.exports = __webpack_public_path__ + "static/media/id7-breiner310.562a8b0b.jpg";